import React from "react";
import htpSVG from "../assets/icons/speedometer_high_throughput.svg";
import Image from "react-bootstrap/Image";

const HighThroughput = () => {
  return (
    <>
      <div id="highthroughput">
        <Image src={htpSVG} alt="speedometer" />
      </div>
    </>
  );
};

export default HighThroughput;
